<template>
  <div class="report-comm">
    <div id="page-trackReport ">
      <div class="head-tab--nav">
        <div class="head-nav h-3">
          <span class="c-normal">{{ Title }}</span>
          <div class="pull-right">
            <el-button type="primary" @click="daochu">{{
              $t("Common.btn_export")
            }}</el-button>
          </div>
        </div>
      </div>
      <div class="trackReport -container">
        <div class="content">
          <div class="flex-wrap">
            <div class="flex-al mb10 mr20">
              <!-- <span class="mr10 fs14 color-666">名单登记时间：</span> -->
              <div class="time-box flex-al fs14">
                <!--<el-date-picker
                  type="date"
                  :placeholder="$t('Report.placeholder1')"
                  v-model="selectForm.starttime"
                  value-format="yyyy-MM-dd"
                  @change="selectSearch()"
                  style="width: 150px;"
                ></el-date-picker>
                <span class="ml10 mr10">{{$t('Report.placeholder2')}}</span>
                <el-date-picker
                  type="date"
                  :placeholder="$t('Report.placeholder3')"
                  v-model="selectForm.endtime"
                  style="width: 150px;"
                  value-format="yyyy-MM-dd"
                  @change="selectSearch()"
                ></el-date-picker>-->
                <el-date-picker
                  style="width: 300px"
                  v-model="selectForm.rang_time"
                  type="daterange"
                  @change="selectChannelSearch"
                  :range-separator="
                    $t(
                      'views.Analysisreport.channelCrmDetailReport.51h4yx8fmf00'
                    )
                  "
                  value-format="yyyy-MM-dd"
                  :start-placeholder="
                    $t(
                      'views.Analysisreport.channelCrmDetailReport.51h4yx8fmzw0'
                    )
                  "
                  :end-placeholder="
                    $t(
                      'views.Analysisreport.channelCrmDetailReport.51h4yx8fnis0'
                    )
                  "
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
            </div>
            <div class="flex-al mb10 mr20">
              <div class="select-box flex-al">
                <el-select
                  v-model="selectForm.coursetype_id"
                  clearable
                  filterable
                  :placeholder="
                    $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
                  "
                  @change="selectSearch"
                >
                  <el-option
                    v-for="(item, index) in coursetypeList"
                    :key="index"
                    :label="
                      `${item.coursetype_cnname}(${item.coursetype_branch})`
                    "
                    :value="item.coursetype_id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex-al mb10 mr20">
              <!-- <span class="mr10 fs14 color-666">{{$t('Report.label_text1')}}</span> -->
              <div class="select-box flex-al">
                <el-select
                  filterable
                  clearable
                  style="width: 180px"
                  @change="selectChannelSearch"
                  v-model="selectForm.client_source"
                  placeholder="请选择招生渠道类型"
                >
                  <!-- <el-option :label="$t('Common.options')" value></el-option> -->
                  <el-option
                    v-for="item in SchoolsourceOption"
                    :key="item.frommedia_id"
                    :label="item.frommedia_name"
                    :value="item.frommedia_name"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex-al mb10 mr20">
              <!-- <span class="mr10 fs14 color-666">{{$t('Report.label_text2')}}</span> -->
              <div class="select-box flex-al">
                <el-select
                  filterable
                  clearable
                  style="width: 180px"
                  @change="selectSearch"
                  v-model="selectForm.channel_id"
                  placeholder="请选择招生渠道明细"
                >
                  <!-- <el-option :label="$t('Common.options')" value></el-option> -->
                  <el-option
                    v-for="item in ChannelOption"
                    :key="item.channel_id"
                    :label="item.channel_name"
                    :value="item.channel_id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex-al mb10">
              <!-- <span class="mr10 fs14 color-666">{{$t('Report.label_text3')}}</span> -->
              <div class="select-box flex-al">
                <el-select
                  filterable
                  clearable
                  style="width: 180px"
                  @change="selectSearch"
                  v-model="selectForm.client_tracestatus"
                  placeholder="请选择客户状态"
                >
                  <!-- 跟踪状态：0待跟踪1持续跟踪2已邀约3已试听4已转正-1已无意向-2无效名单', -->
                  <!-- <el-option :label="$t('Common.options')" value></el-option> -->
                  <el-option
                    :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8frsw0')"
                    value="0"
                  ></el-option>
                  <el-option
                    :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fs700')"
                    value="1"
                  ></el-option>
                  <el-option
                    :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fss80')"
                    value="2"
                  ></el-option>
                  <el-option
                    :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8ft6c0')"
                    value="3"
                  ></el-option>
                  <el-option
                    :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fthw0')"
                    value="4"
                  ></el-option>
                  <el-option
                    :label="$t('Customersmanage.bvN1')"
                    value="6"
                  ></el-option>
                  <el-option
                    :label="$t('Customersmanage.bvN2')"
                    value="7"
                  ></el-option>
                  <el-option
                    :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fttw0')"
                    value="-1"
                  ></el-option>
                  <el-option
                    :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fu5s0')"
                    value="-2"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <!-- <el-input clearable placeholder="请输入姓名、手机号、报名课程" class="input-cont input-keword" @change="handleSelectKeyword()" v-model="selectForm.keyword"  clearable></el-input>
            <el-button type="primary" class="btn-inquire"  @click="handleSelectKeyword()">查询</el-button>-->
          </div>
          <!-- <div class="content-nav--head text-1">
            <div class="c-n--head_lf">
              <div class="time head-right">
                <el-date-picker
                  type="date"
                  placeholder="开始日期"
                  v-model="selectForm.starttime"
                  value-format="yyyy-MM-dd"
                  @change="selectSearch()"
                  style="width: 150px;"
                ></el-date-picker>
                <span>至</span>
                <el-date-picker
                  type="date"
                  placeholder="结束日期"
                  v-model="selectForm.endtime"
                  style="width: 150px;"
                  value-format="yyyy-MM-dd"
                  @change="selectSearch()"
                ></el-date-picker>
              </div>
            </div>
          </div>-->
          <div class="report-table-cont">
            <reportTbale
              :list="tableList.list"
              :options="tableList.options"
              :columns="tableList.columns"
              :issetting="true"
              :operates="tableList.operates"
              :tableOperate="tableList.tableOperate"
              @toggleEditableColumn="toggleEditableColumn"
            ></reportTbale>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="dataNumber"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑列 -->
    <el-dialog
      :title="$t('Common.editTableTitle')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="$t('Common.editTableTitles')"
        v-model="oprateColumn"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate()">{{
          $t("Common.btn_confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import reportTbale from "../../components/Table/reportTbale";
import storeAnalysisreport from "../../views/Analysisreport/analysisreport.js";
export default {
  name: "reportTable",
  components: {
    reportTbale,
  },
  props: ["Title", "wayString", "placehold"],
  data() {
    return {
      wayProp: "", //方法名
      // 表格筛选
      selectForm: {
        rang_time: "",
        starttime: "",
        endtime: "",
        keyword: "",
        client_source: "",
        client_tracestatus: "",
        channel_id: "",
                coursetype_id: "",

      },
      // 招生渠道类型
      SchoolsourceOption: [],
      ChannelOption: [], // 招生渠道明细
            coursetypeList: [],

      tableList: {
        operates: {
          width: 200,
          label: this.$t("Common.operatesLabel"),
          align: "center",
          isfixed: true,
          fixed: "right",
          list: [],
        },
        tableOperate: {
          label: "11",
          operate: true,
          align: "center",
          fixed: "right",
        },
        options: {
          stripe: false,
          tableHeight: Number,
          mutiSelect: false, // 是否支持列表项选中功能
          highlightCurrentRow: true, // 是否支持当前行高亮显示
        },
        columns: [],
        columnWidth: [],
        list: [],
      },
      // 分页
      dataNumber: 0, //数据总数
      pageNum: 1,
      pageSize: 10,
      currentPage: 1,
      sizeArray: [10, 20, 30, 40],
      // 编辑列
      settingVisible: false,
      data: [],
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptions: {},
    };
  },
  created() {
    (() => {})(this.wayString, "this.wayString");
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.tableList.options.tableHeight = this.$Common.getTableHeight(295);

    this.selectForm.rang_time = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    this.selectForm.starttime = this.$Common.getAppointedDate(2, 0).startDate;
    this.selectForm.endtime = this.$Common.getAppointedDate(2, 0).endDate;

    this.Analysisreport(0);
        this.courseTypeApi();

    this.getSourceData(); //获取招生渠道类型
    this.getChannelData(); //获取招生渠道明细
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
        //下拉列表->获取班组列表--zjb
    courseTypeApi() {
      storeAnalysisreport.courseTypeApi({}).then((res) => {
        if (res.data.code === 200) {
          this.coursetypeList = res.data.data.list;
        } else {
          this.coursetypeList = [];
        }
      });
    },
    //分析报表列表及导出报表
    Analysisreport(is_export) {
      storeAnalysisreport[this.wayString]({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        p: this.currentPage,
        num: this.pageSize,
        is_count: "1", //是否需要总数
        //数据筛选
        starttime: this.selectForm.starttime,
        endtime: this.selectForm.endtime,
        client_source: this.selectForm.client_source,
        channel_id: this.selectForm.channel_id,
        client_tracestatus: this.selectForm.client_tracestatus,
                coursetype_id: this.selectForm.coursetype_id,

        is_export: is_export,
      }).then((res) => {
        var Columns = res.data.data.field;
        this.allColumns = res.data.data.field; //刚开始 存储所有的后台传过来的数据
        var fieldColumns = res.data.data.field; //编辑之后，需要显示的数据
        //存储要显示的['show'+this.wayString]
        if (JSON.parse(localStorage.getItem("reportColumns"))) {
          let obj = JSON.parse(localStorage.getItem("reportColumns"));
          (() => {})(this.wayString);
          let valueName = "all" + this.wayString;
          (() => {})(valueName, "属性名属性名");
          obj[valueName] = this.allColumns; //  allstureport
          this.$Tool.setStorage("reportColumns", obj);
          (() => {})("有数据", obj);
        } else {
          //第一次 无数据
          (() => {})("无数据");
          let obj1 = {};
          let valueName = "all" + this.wayString;
          obj1[valueName] = this.allColumns; //  allstureport
          this.$Tool.setStorage("reportColumns", obj1);
        }
        if (
          JSON.parse(localStorage.getItem("reportColumns"))[
            "show" + this.wayString
          ]
        ) {
          this.showColumn = JSON.parse(localStorage.getItem("reportColumns"))[
            "show" + this.wayString
          ];
          Columns = this.showColumn;
          fieldColumns = this.showColumn;
        }
        // 自定义编辑列
        var settingOprateData = this.$Common.settingOprateData(fieldColumns);
        this.data = settingOprateData.data;
        this.oprateColumn = settingOprateData.oprateColumn;
        this.dataNumber = parseInt(res.data.data.allnum);
        this.tableList.columns = Columns;
        // this.tableList.columns[1].ismethod = true;
        if (res.data.code === 200) {
          this.tableList.list = res.data.data.list;
        } else {
          this.tableList.options.errortip = res.data.msg;
          this.tableList.list = [];
        }
      });
    },
    //获取招生渠道类型
    getSourceData() {
      storeAnalysisreport
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          this.SchoolsourceOption = res.data.data.list;
        });
    },
    //获取招生渠道明细
    getChannelData() {
      storeAnalysisreport
        .getChannel({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          channel_medianame: this.selectForm.client_source,
        })
        .then((res) => {
          this.ChannelOption = res.data.data.list;
        });
    },
    // 数据检索
    selectChannelSearch() {
      this.selectForm.starttime = this.selectForm.rang_time
        ? this.selectForm.rang_time[0]
        : "";
      this.selectForm.endtime = this.selectForm.rang_time
        ? this.selectForm.rang_time[1]
        : "";
      this.currentPage = 1;
      this.selectForm.channel_id = "";
      this.getChannelData(); //获取招生渠道明细
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    // 数据检索
    selectSearch() {
      this.currentPage = 1;
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    // 自定义编辑列
    handClickOprate() {
      let allcom = JSON.parse(localStorage.getItem("reportColumns"));
      // (() => {})(this.wayString)
      // (() => {})(allcom)
      let allnum = allcom["all" + this.wayString];
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item, index) => {
        (() => {})(allnum[parseInt(item)]);
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      let obj = this.$Tool.getStorage("reportColumns");
      obj["show" + this.wayString] = this.showColumns;
      this.$Tool.setStorage("reportColumns", obj);

      this.settingVisible = false;
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    handleClose(done) {
      done();
    },
    // 分页
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pageSize = val;
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    // 导出操作
    daochu() {
      let url = storeAnalysisreport[this.wayString + "1"]();
      var is_export = 1;
      let language_type = this.$Tool.getStorage("language")
        ? this.$Tool.getStorage("language")
        : "zh";
      (() => {})(this.tableList.list.length);
      if (this.tableList.list.length > 0) {
        let urls = `${url}?marketer_id=${this.marketer_id}&token=${
          this.token
        }&school_id=${this.school_id}&company_id=${
          this.company_id
        }&is_export=${is_export}&starttime=${
          this.selectForm.starttime
        }&endtime=${this.selectForm.endtime}&client_source=${
          this.selectForm.client_source
        }&client_tracestatus=${this.selectForm.client_tracestatus}&channel_id=${
          this.selectForm.channel_id
        }&coursetype_id=${this.selectForm.coursetype_id}&language_type=${language_type}&re_postbe_id=${this.$Tool.getStorage(
          "re_postbe_id"
        )}`;
        (() => {})(urls);
        window.open(this.$buildExportUrl(urls), "_blank");
      } else {
        this.$message.error(this.$t("Report.errorMessage1"));
      }
    },
    getSTime(val) {
      this.Analysisreport(0);
    },
  },
};
</script>

<style lang="less"></style>
